import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomModal from "../../components/Modals/CustomModal";
import { Container, Modal } from "react-bootstrap";

const StripeCancelScreen = () => {
  const { t } = useTranslation();
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t("stripe.successTitle")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>{t("stripe.successMessage")}</p>
      </Modal.Body></>);
    setLinkModal(t('link.dashboard'));
    setShowCustomModal(true);
    setLoading(false);
  }, []);
  
  return (
    <Container className="text-center mt-5">
        <h2>{t("stripe.stripeCancelScreen")}</h2>
    </Container>
  );
}

export default StripeCancelScreen;